/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Share_LinkInputs */

const en_dialog_share_link = /** @type {(inputs: Dialog_Share_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share link`)
};

const es_dialog_share_link = /** @type {(inputs: Dialog_Share_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compartir enlace`)
};

/**
* | output |
* | --- |
* | "Share link" |
*
* @param {Dialog_Share_LinkInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_share_link = /** @type {((inputs?: Dialog_Share_LinkInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Share_LinkInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_share_link(inputs)
	return en_dialog_share_link(inputs)
});